var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimChevronRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Percorso",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0,
    d: "M 65.104126 44.746094 C 65.104126 43.671875 64.664551 42.695313 63.883301 41.865234 L 33.70752 11.884766 C 32.97522 11.103516 31.949829 10.712891 30.82666 10.712891 C 28.531738 10.712891 26.822754 12.421875 26.822754 14.716797 C 26.822754 15.839844 27.262329 16.816406 27.994629 17.597656 L 55.240723 44.746094 L 27.994629 71.894531 C 27.262329 72.675781 26.822754 73.701172 26.822754 74.775391 C 26.822754 77.070313 28.531738 78.779297 30.82666 78.779297 C 31.949829 78.779297 32.97522 78.388672 33.70752 77.607422 L 63.883301 47.626953 C 64.664551 46.796875 65.104126 45.820313 65.104126 44.746094 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimChevronRight);
export default __webpack_public_path__ + "static/media/sim-chevron-right.9c980be45c7704e9996600af184fe5ca.svg";
export { ForwardRef as ReactComponent };